import React, {useEffect} from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import BusinessIcon from '@material-ui/icons/Business';
import {useDispatch, useSelector} from "react-redux";
import {fetchCustomers} from "../../../../actions";
import CircularProgress from "../../../../components/prefabricated/CircularProgress";
import URLSearchParams from "url-search-params";
import {useHistory} from "react-router-dom";
import {isCurrentUserMemberOf} from "../../../../util/bbHelpers";

export const CustomersAsListItems = (props) => {

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const dispatch = useDispatch();
    const history = useHistory();

    const customers = useSelector(({customer}) => customer.customers);
    const {authUser} = useSelector(({auth}) => auth);
    const {loadingCustomers, loadingCustomersError, customerInView} = useSelector(({customer}) => customer);
    const numCustomers = customers ? Object.keys(customers).length : 0;

    const sortedCustomers =  customers ? Object.keys(customers).map((k) => customers[k]) : [];
    sortedCustomers.sort(function(a, b) {
        const textA = a.CustomerName.toUpperCase();
        const textB = b.CustomerName.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    // console.log("sorted customers is ", sortedCustomers)

    //list item selection
    const [selectedIndex, setSelectedIndex] = React.useState(1);


    useEffect(() => {
        // console.group("customersAsListItems")
        // console.log("customersAsListItems here is the store", customers)
        if (customers == null) {
            // console.log("Customers is empty, fetching.")
            dispatch(fetchCustomers());
        }
        // console.groupEnd()

        //this will override any search param for clientId.
        const params = new URLSearchParams(window.location.search);
        // params.delete("clientID")
        const urlClient = params.get("clientID")
        if(urlClient && urlClient !== selectedIndex) {
            // console.log("setting index of multi board to", urlClient);
            setSelectedIndex(urlClient);
        }


        /*  jfd*******************************
         *   Appending clientID to URL
             ********************************** */
        const isPartner = isCurrentUserMemberOf(authUser, "partner");
        const isAdmin =  isCurrentUserMemberOf(authUser, "admin");
        const isStaff = isCurrentUserMemberOf(authUser, "staff");

        if ((isPartner
            || isAdmin
            || isStaff
        )) {
            //if they are a partner, staff, or admin, append the clientID search param

            if(customers
                && !params.has("clientID")
                && customerInView
            ) {
                //set the urlParameters
                params.set("clientID", customerInView)
                // console.log("getting params", params.get("clientID"));
                history.replace({
                    search: params.toString(),
                })
            }
        }

    }, [customers, dispatch, customerInView, window.location.search]);

    //set default item selection based on state
    // if (customerInView) {
    //     setSelectedIndex(customerInView);
    // }

    const handleListItemClick = (event, customerId) => {
        setSelectedIndex(customerId);

        //this will override any search param for clientId.
        const params = new URLSearchParams(window.location.search);
        params.set("clientID", customerId)
        // console.log("getting params", params.get("clientID"));

        history.push({
            search: params.toString(),
        })

        //change the state of the app
        // dispatch(setCustomerInView(customerId));
    };

    /**************************/
    /*END Setup State and Dispatch*/
    /**************************/

    // console.log("This is a map of the customers: ");
    // Object.keys(customers).map((customerId) => {
    //     console.log("Inside the map. customer.CustomerId returns", customer, customer.CustomerId)
    // });
    return (
        <div>
            { !loadingCustomers && numCustomers &&
            sortedCustomers.map((customer) => (
                    <ListItem
                        button
                        key={`${customer.CustomerId}_listed_item`}
                        selected={selectedIndex === customer.CustomerId}
                        onClick={(event) => handleListItemClick(event, customer.CustomerId)}
                    >
                        <ListItemIcon>
                            <BusinessIcon/>
                        </ListItemIcon>
                        <ListItemText primary={customer.CustomerName}/>
                    </ListItem>
                ))
            }
            {
                loadingCustomers &&
                <div className="loader-view">
                    <CircularProgress/>
                </div>
            }
            {
                (!loadingCustomers && ( loadingCustomersError || !customers || !Object.keys(customers).length)) &&
                <div className="loader-view">
                    !
                </div>
            }
        </div>
    );
}